import React from "react";

function Project() {
  const projects = [
    {
      title: "Portfolio Website",
      description:
        "A personal portfolio built using React, Bootstrap, and React Router to showcase my skills and projects.",
      tech: "React, Bootstrap, JavaScript",
      link: "/about",
    },
    {
      title: "E-Commerce",
      description:
        "A E-com store built using React ,Tailwind An API built with PHP and MySQL to handle authentication, product management, and orders.",
      tech: "React, Tailwind, PHP, MySQL, REST API",
      link: "https://ecommerce.my-style.in/?i=1",
    },
    {
      title: "Study Material Hub",
      description:
        "A full-stack app for storing and sharing study materials, with file upload and search functionality.",
      tech: "React, CSS, JavaScript, PHP, MySQL",
      link:"https://smit-fataniya.great-site.net/?i=1",
    },

    {
      title: "Expenses Tracker",
      description:
        "A full-stack app for managing expenses, with user authentication and reporting features.",
      tech: "React, CSS, JavaScript, jsPDF",
      link:"https://expense-tracker-smit.vercel.app/",
    },
  ];

  return (
    <section id="projects" className="py-5 min-vh-100 text-light">
      <div className="container">
        <h2 className="text-center fw-bold mb-5">🚀 My <span className="text-info">Projects</span></h2>

        <div className="row g-4">
          {projects.map((project, index) => (
            <div className="col-md-4" key={index}>
              <div className="card-modern h-100 shadow-lg p-3">
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title fw-bold text-white">{project.title}</h5>
                  <p className="card-text" style={{ color: "#8b949e" }}>{project.description}</p>
                  <p className="mt-auto mb-3"><strong className="text-info">Tech:</strong> {project.tech}</p>

                  <div className="project-buttons">
                    {project.link ? (
                      <a href={project.link} className="btn btn-sm btn-outline-light me-2" target="_blank" rel="noopener noreferrer">Live Demo</a>
                    ) : (
                      <button className="btn btn-sm btn-outline-secondary me-2" disabled>Live Demo</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Project;
